<template>
  <ProcedimentosSaude
    :title="especialidade"
    :termo-consulta="especialidade"
    :breadcrumb="breadcrumb"
    :urls="urls"
    :tipo="'especialidades'"
  >
    <template slot="header-slot">
      <div class="col-xs-12">
        <p>
          Aqui você encontra as solicitações agendadas da especialidade
          <span class="destaque-header">{{ especialidade }}</span
          >.
        </p>
      </div>
    </template>
  </ProcedimentosSaude>
</template>

<script>
import { ProcedimentosSaude } from '../../../components'

export default {
  components: {
    ProcedimentosSaude
  },
  data() {
    return {
      urls: {
        espera: 'procedimentos-saude/lista-especialidades',
        agendados: 'procedimentos-saude/lista-especialidades-agendados'
      },
      especialidade: ''
    }
  },
  created() {
    const { especialidade } = this.$route.params

    this.especialidade = especialidade
  },
  computed: {
    breadcrumb() {
      return [
        {
          label: 'Minha Saúde',
          named_link: { name: 'procedimentos_saude' }
        },
        {
          label: this.especialidade
        }
      ]
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/views/public/procedimentos_saude/PorEspecialidade.vue